import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {CandidatService} from "../../../../services/candidat.service";
import {Candidat} from "../../../../models/Candidat";
import {AuthService} from "../../../../services/auth.service";
import {Base64} from "../../../../shared/utils/utils.functions";
import { MissionService } from '../../../../services/mission.service';
import { CandidatStatusOnMission } from '../../../../shared/utils/enums';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss'
})
export class DetailsComponent implements OnInit {

  // Mision details list
  calenderLoader = false;
  userId: any;
  randomData: any;
  user: any;
  events: any;
  disponibilityDays: any;

  candidat: Candidat
  loading = false;
  public allDocs = {
    "IDENTITÉ": [
      {
        label: "Passeport",
        attr: "passport"
      },
      {
        label: "Titre de séjour (Recto)",
        attr: "sejourFace"
      },
      {
        label: "Titre de séjour (Verso)",
        attr: "sejourBack"
      },
      {
        label: "Votre pièce d'identité (Recto)",
        attr: "idFace"
      },
      {
        label: "Votre pièce d'identité (Verso)",
        attr: "idBack"
      }
    ],
    "RELEVE D'IDENTITE BANCAIRE": [
      {
        label: "Relevé d'identité bancaire",
        attr: "bankDetails"
      }
    ],
    "ASSURANCE MALADIE": [
      {
        label: "Carte vitale ou attestation de sécurité sociale",
        attr: "socialSecurityCertif"
      }
    ],
    "JUSTIFICATIF DE DOMICILE": [
      {
        label: "Pièce d'identité de la personne qui vous héberge",
        attr: "letterSignedByHost"
      },
      {
        label: "Lettre de l'hébergeant signée certifiant que vous habitez chez lui",
        attr: "justificatifDomicileHost"
      },
      {
        label: "Justificatif de domicile de moins d'un an au nom de l'hébergeant",
        attr: "justificatifDomicile"
      },
      {
        label: "Facture de téléphone",
        attr: "phoneBill"
      },
      {
        label: "Facture d'électricité ou de gaz",
        attr: "electroBill"
      },
      {
        label: "Quittance de loyer émanant d'un organisme social ou d'une agence immobilière",
        attr: "quittanceImmob"
      },
      {
        label: "Titre de propriété",
        attr: "propertyTitle"
      },
      {
        label: "Facture d'eau",
        attr: "waterBill"
      },
      {
        label: "Avis d'imposition ou certification de non imposition",
        attr: "certImpos"
      },
      {
        label: "Justificatif de taxe d'habitation ou de taxe foncière",
        attr: "taxBill"
      },
      {
        label: "Attestation ou facture d'assurance du logement",
        attr: "assuranceLogement"
      }
    ],
    "CARTE GRISE DE VOTRE VÉHICULE": [
      {
        label: "Carte grise de votre véhicule",
        attr: "carteGrise"
      }
    ],
    "ASSURANCES RESPONSABILITÉ PROFESSIONNELLE SI VOUS EN DISPOSEZ": [
      {
        label: "Assurances responsabilité professionnelle si vous en disposez",
        attr: "enrollmentCertificate"
      }
    ],
    "PROFESSION": [
      {
        label: "Votre CVs",
        attr: "cv"
      },
      {
        label: "Diplôme principal",
        attr: "firstDiplome"
      },
      {
        label: "Autre diplôme (Deuxième)",
        attr: "secondDiplome"
      },
      {
        label: "Autre diplôme (Troisième)",
        attr: "thirdDiplome"
      }
    ]
  }

  constructor(
    private candidatService: CandidatService,
    private auth: AuthService,
    private route: ActivatedRoute,
    private missionApi: MissionService,
    public dialogRef: MatDialogRef<DetailsComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {


  }

  ngOnInit(): void {
    // this.getCandidatById()
    this.getCandidateDetailByIdEstaId()
    this.fetchMissionByCondidat();
    this.getDisponibility()
  }

  round(num: number) {
    return Math.round(num)
  }


  onDialogClose(): void {
    this.dialogRef.close();
  }
  getCandidatById() {
    this.candidatService.getCandidatDetailByIdEstaIdV2(this.data.candidature.candidatId, 0).subscribe({
      next: data => {
        // this.candidat = data;
      }
    });
  }
  getEvaluationByCandidatId() {
     this.candidatService.getEvaluationByCandidatId(this.data.candidature.candidatId).subscribe({
       next: data => {
         this.candidat.ratingCount = data?.details?.length || 0;
      }
    });
  }
  getCandidateDetailByIdEstaId() {
    this.loading = true;    
    let etbId = !!this.data.candidature.establishmentId ? this.data.candidature.establishmentId : 0;
    
    this.candidatService.getCandidatDetailByIdEstaIdV2(this.data.candidature.candidatId, etbId).subscribe({
      next: data => {
        this.candidat = data;
        if (this.candidat?.birthDay)
        {
          this.candidat.age = this.calculateYears(this.candidat?.birthDay);
        }
        if (this.candidat?.graduationYear)
        {
          this.candidat.yearsOfExperiances = this.calculateYears(this.candidat?.graduationYear);
        }
        if (this.candidat?.creationDate)
        {
          this.candidat.inscriptionYears = this.getAccountCreationString(this.candidat?.creationDate);
        }
        try {
          this.getEvaluationByCandidatId();
        } catch
        {

        }

        this.loading = false;
      }
    });
  }

 getAccountCreationString(creationDate: string): string {
    console.log(this.candidat);

    const creation = new Date(creationDate);
    const now = new Date();
    const diffTime = now.getTime() - creation.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    // Check if the account was created less than 30 days ago
    if (diffDays < 30) {
        // Check civility and return appropriate string
        if (this.candidat?.civility.toLowerCase() === 'mr') {
            return "Nouveau";
        } else {
            return "Nouvelle";
        }
    }

    const month = creation.getUTCMonth() + 1; // Months are 0-based in JavaScript
    const year = creation.getUTCFullYear();
    const formattedMonth = month < 10 ? `0${month}` : month.toString();

    return `Inscrit(e) sur la plateforme depuis : ${formattedMonth}-${year}`;
}


  calculateYears(date: string): number {
  const valueDate = new Date(date);
  const today = new Date();

  let age = today.getFullYear() - valueDate.getFullYear();
  const monthDifference = today.getMonth() - valueDate.getMonth();
  const dayDifference = today.getDate() - valueDate.getDate();

  // Adjust age if the current date is before the birthdate in the current year
  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }

  return age;
}

  download(attr: any) {
    //@ts-ignore
    if (this.candidat[attr].includes('/api')) {
          //@ts-ignore
      this.downloadFile(this.candidat[attr], attr)
      return;
    }
        //@ts-ignore
    this.downloadBase64File(this.candidat[attr], attr)
  }

  downloadFile(_dataFile: string, _filename: string) {
    this.http.get(`${environment.api.BASE_URL}${_dataFile}`, {
      responseType: 'blob',
      observe: 'response'
    }).subscribe({
      next: async (response: any) => {
        const blob = response.body as Blob;
        let extension = await this.detectFileExtension(blob);

        // Get MIME type from Content-Type header
        const mimeType = response.headers.get('Content-Type') || blob.type || 'application/octet-stream';

        // Detect file extension based on MIME type
        // const extension = this.getExtensionFromMime(mimeType);
        const fileName = `${_filename}${extension}`;

        // Create and trigger download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (err: any) => {
        console.error('File download failed:', err);
      }
    });
  }

    private getExtensionFromMime(mimeType: string): string {
    const map: Record<string, string> = {
      'application/pdf': '.pdf',
      'image/png': '.png',
      'image/jpeg': '.jpg',
      'image/jpg': '.jpg',
      'image/gif': '.gif',
      'text/plain': '.txt',
      'text/csv': '.csv',
      'application/zip': '.zip',
      'application/json': '.json',
      'application/vnd.ms-excel': '.xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
      'application/msword': '.doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
      'application/vnd.ms-powerpoint': '.ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx'
    };

    return map[mimeType] || '';
  }

  private async detectFileExtension(blob: Blob): Promise<string | null> {
    const buffer = await blob.slice(0, 8).arrayBuffer();
    const bytes = new Uint8Array(buffer);
    const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('').toUpperCase();

    if (hex.startsWith('25504446')) return '.pdf'; // PDF
    if (hex.startsWith('89504E47')) return '.png'; // PNG
    if (hex.startsWith('FFD8FF')) return '.jpg';   // JPEG
    if (hex.startsWith('47494638')) return '.gif'; // GIF
    if (hex.startsWith('504B0304')) return '.zip'; // ZIP, DOCX, XLSX, PPTX
    if (hex.startsWith('D0CF11E0')) return '.doc'; // Old MS Office

    return null;
  }

  downloadBase64File(_dataFile: string, filename: string): void {
    let decoded = Base64.decode(_dataFile);
    let extension = undefined;
    let lowerCase = decoded.toLowerCase();
    if (lowerCase.indexOf('png') !== -1) extension = 'png';
    else if (lowerCase.indexOf('pdf') !== -1) extension = 'pdf';
    else  extension = 'jpg';
    const arrayBuffer = this.base64ToArrayBuffer(_dataFile);
    const blob = new Blob([arrayBuffer], {
      type:
        extension == 'pdf' ? 'application/pdf' : 'image/' + extension,
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename + '.' + extension;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  base64ToArrayBuffer(base64: string) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  getOrderedDocs() {
    return Object.entries(this.allDocs)
      .map(([category, docs]) => {
        // @ts-ignore
        const filteredDocs = docs.filter(doc => !!this.candidat[doc.attr]);
        return filteredDocs.length > 0 ? {category, docs: filteredDocs} : null;
      })
      .filter(category => category !== null);
  }

  getDisponibility() {
    this.missionApi.addGetAvailability(this.data.candidature.candidatId).subscribe({
      next: ({ nonAvailabilityDates }) => {
        this.disponibilityDays = nonAvailabilityDates;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  fetchMissionByCondidat() {
    this.calenderLoader = true;
    this.missionApi.getMissionsByCondidatV2(this.data.candidature.candidatId).subscribe({
      next: (res) => {
        this.events = res?.map((el: any, key: any) => {
          const diffDays = this.getDaysDifference(el?.startdate,el?.enddate,el?.starttime,el?.endtime);
          if (diffDays) {
            return {
              start: new Date(el.startdate),
              end: new Date(el.enddate),
              title: el?.missionTitle || 'Mission ' + el.id,
              etablissementNom: el?.etablissementNom,
              site: el?.adresseDto?.name,
              serviceAffectationsName: el?.serviceAffectationsName,
              user: this.user,
              color:
                el.statusOfCandidatOnMission ==
                CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
                  ? '#01a167'
                  : '#FFC114',
              allDay: true,
              data: {
                ...el,
                user: {
                  ...this.user,
                  numsiret: res.numsiret,
                  typeSecteur: el.typeSecteur,
                },
              },
            };
          } else {
            return {
              id: el?.id,
              start: new Date(el.startdate),
              end: new Date(el.startdate),
              title: el?.missionTitle || 'Mission ' + el.id,
              etablissementNom: el?.etablissementNom,
              site: el?.adresseDto?.name,
              serviceAffectationsName: el?.serviceAffectationsName,
              user: this.user,
              color:
                el.statusOfCandidatOnMission ==
                CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
                  ? '#01a167'
                  : el.statusOfCandidatOnMission ==
                      CandidatStatusOnMission.REJECTED ||
                    el.statusOfCandidatOnMission ==
                      CandidatStatusOnMission.CANCELED_BY_CANDIDATE
                  ? 'red'
                  : '#FFC114',
              allDay: true,
              data: {
                ...el,
                user: {
                  ...this.user,
                  numsiret: res.numsiret,
                  typeSecteur: el.typeSecteur,
                },
              },
            };
          }
        });
        this.randomData = res?.map((el: any) => {
          return {
            title: el?.missionTitle || 'Mission ' + el.id,
            secteur: el.typeSecteur || 'N/A',
            contractType:
              el?.typecontat == 'LIBERAL' ? 'INTÉRIM' : el?.typecontat,
            startDate: el.startdate,
            endDate: el.enddate,
            renumeration: el.compensationproposednet || 0,
            user: this.user,
            color:
              el.statusOfCandidatOnMission ==
              CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH
                ? '#01A167'
                : el.statusOfCandidatOnMission ==
                    CandidatStatusOnMission.REJECTED ||
                  el.statusOfCandidatOnMission ==
                    CandidatStatusOnMission.CANCELED_BY_CANDIDATE
                ? 'red'
                : '#FFC114',
            candidatures: el.candidatures || 'N/A',
            currency: '$',
            status: el.statusOfCandidatOnMission,
          };
        });
        this.calenderLoader = false;
      },
      error: (err) => {
        console.log(err);
        this.calenderLoader = false;
      },
      complete: () => {},
    });
  }

  getDaysDifference(startDate: Date, endDate: Date, startTime: string, endTime: string): number {
    // Parse the startTime and endTime into hours and minutes
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);
  
    // Set the time for startDate and endDate
    const startDateTime = new Date(startDate);
    startDateTime.setHours(startHour, startMinute, 0, 0);
  
    const endDateTime = new Date(endDate);
    endDateTime.setHours(endHour, endMinute, 0, 0);
  
    // Calculate the difference in full days and remaining hours
    const difference = endDateTime.getTime() - startDateTime.getTime();
    const fullDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    const remainingHours = (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60);
  
    // Apply the rule: if there are any remaining hours, add an extra day
    const daysCount = remainingHours > 0 ? fullDays + 1 : fullDays;
  
    // Ensure at least 1 day is counted, if the difference is less than a day
    return daysCount === 0 ? 1 : daysCount;
  }

}
